import Vue from 'vue';
import Vuex from 'vuex';
// import * as event from './modules/event';
import * as me from './modules/me';
// import * as attendees from './modules/attendees';
// import * as organisations from './modules/organisations';
import * as messages from './modules/messages';
import * as meetings from './modules/meetings';
import * as slots from './modules/slots';
import * as videos from './modules/videos';
import * as videoarchives from './modules/videoarchives';
// import * as tracks from './modules/tracks';
import * as customfields from './modules/customfields';
import * as groups from './modules/groups';
import * as appointments from './modules/appointments';
// import * as calendar from './modules/calendar';
// import * as search from './modules/search';

import { SEARCH_BUTTON_ENABLED, SETTING_MESSAGES_ON, SETTING_NOTE_ENABLE } from '../components/Config';  // , SEARCHABLE_FIELDS_ATTENDEE
import EventService from "../services/EventService";
// import { mergeAll, flattenAnswers } from "../components/Utils";


Vue.use(Vuex);

const TOKEN_SECONDS_MIN = 60 * 60 * 24; // Renew if token has less than 24 hour remaining
const HOUR_IN_MS = 60 * 60 * 1000;
var intervalRenewToken = null;
const LS = { // LocalStorage naming enum
    DISPLAY_TZ: 'DISPLAY_TZ',
};
const DEFAULT_TIMEZONE = 'GMT';

export default new Vuex.Store({
    modules: {
        // event,
        me,
        // attendees,
        // organisations,
        messages,
        meetings,
        slots,
        videos,
        videoarchives,
        // tracks,
        customfields,
        groups,
        appointments,
        // search,
        // calendar, // - JUST USE meetings/appointments FOR NOW
    },
    state: {
        loading: -1,  // Initial no-load state
        isManager: false,
        attendeeName: null, // Currently taken from jwt.payload.name
        attendeeId: 0, // Ultimately sourced from EventService.getMandatedAttendeeId()
        authTokenUpdatedAt: null, // 
        profileBlob: null,
        displayTZ: null, // Timezone the Attendee wants to view the site as
    },
    mutations: {
        SET_LOADING(state, int) {
            state.loading = int;
        },
        SET_AUTH_TOKEN_UPDATED_AT(state, dateObj) {
            state.authTokenUpdatedAt = dateObj;
        },
        SET_MANAGER(state, bool) {
            state.isManager = bool;
        },
        SET_ATTENDEE_NAME(state, str) {
            state.attendeeName = str;
        },
        SET_ATTENDEE_ID(state, id) {
            state.attendeeId = id;
        },
        SET_PROFILE_BLOB(state, str) {
            state.profileBlob = str;
        },
        SET_DISPLAY_TZ(state, str) {
            state.displayTZ = str;
        },
    },
    actions: {
        loadingStarted(context) {
            context.commit('SET_LOADING', 0);
        },
        loadingComplete(context) {
            console.log("Loading is now complete");
            context.commit('SET_LOADING', 100);
        },
        authTokenUpdated(context) {
            context.commit('SET_AUTH_TOKEN_UPDATED_AT', new Date());
        },
        renewAuthToken(context) {
            let remainingSeconds = EventService.authTokenRemainingSeconds();
            if (remainingSeconds > 0 && remainingSeconds < TOKEN_SECONDS_MIN) {
                console.log("Renewing token");
                EventService.requestAuthToken(false).then(() => {
                    context.dispatch('authTokenUpdated');
                });
            }
        },
        checkAuthToken(context) {
            return EventService.requestAuthToken().then(() => {
                if (EventService.hasValidAuthToken()) {
                    context.dispatch('authTokenUpdated');
                    context.commit('SET_MANAGER', EventService.isManager());
                    context.commit('SET_ATTENDEE_NAME', EventService.jwtPayloadName());
                }
            });
        },
/*        login ({ dispatch }, credentials) {
            return EventService.login(credentials.email, credentials.password)
                .then(({ data }) => {
                    console.log("LOGIN RESPONSE:", data);

                    EventService.setAuthToken(data.token);

                    dispatch('me/insertMe', data);
                    dispatch('loadAttendeeData');
                    return true;
                })
                .catch(error => {
                    console.log("LOGIN FAILED:", error);
                    return false;
                });
        },
        logout({dispatch}) {
            // Wipe all attendee-specific vuex data and cookies

            dispatch('me/reset');
            dispatch('meetings/reset');
            dispatch('messages/reset');
            dispatch('appointments/reset');

            EventService.logout().then(() => {
                location.reload();
            });
        },

 */
        loadEventData({dispatch}) {
            return Promise.all([
                //dispatch('event/fetchEvent'),
                dispatch('slots/fetchSlots', true),
                //dispatch('videos/fetchLiveVideos'),  // Should this be here? Move to StatusBoard?
                //dispatch('tracks/fetchTracks'),
                //dispatch('customfields/fetchCustomFields'),
                //dispatch('appointments/fetchAppointments'),
            ]);

        },
        loadAttendeeData({dispatch, rootGetters}) {
            return Promise.all([
                // dispatch('me/fetchMe'),
                dispatch('attendees/fetchAttendees'),
                dispatch('organisations/fetchOrganisations'),
                dispatch('messages/fetchMessages'),
                dispatch('meetings/fetchMeetings', rootGetters['me/currentAttendee']),

                // TODO: Find a way to perform the initial searches async?
                dispatch('search/filterAttendees'),
                dispatch('search/filterOrganisations'),
            ]);
        },
        loadProfileBlob(context) {
            if (! context.getters['currentProfileBlob']) {
                return EventService.getHTMLProfileBlob().then(res => {
                    context.commit('SET_PROFILE_BLOB', res.data);
                });
            } else {
                return Promise.resolve('success');
            }
        },
        deleteProfileBlob(context) {
            context.commit('SET_PROFILE_BLOB', null);
        },

        updateDisplayTZ(context, tz) {
            context.commit('SET_DISPLAY_TZ', tz);
            localStorage.setItem(LS.DISPLAY_TZ, tz);
        },

        loadLocalStorage() {  // context
            // Pull in anything from LocalStorage that we want to track

            // DO NOT DEFAULT TO LOCAL TZ - SHOULD USE EVENT TZ!
            // context.dispatch(
            //     'updateDisplayTZ', 
            //     localStorage.getItem(LS.DISPLAY_TZ) ?? Intl.DateTimeFormat().resolvedOptions().timeZone
            // );
        },
        /* Timezone Requirements:
         * 1: Must default to the EventTZ rather than LocalTZ.
         * 2: Timezones may change. If LocalStorageTZ doesn't match EventTZ or DeviceTZ, wipe LocalStorageTZ
         */
        loadTimezone(context) {
            var tz_event = context.getters['currentEvent'].timezone || DEFAULT_TIMEZONE;
            var tz_device = Intl.DateTimeFormat().resolvedOptions().timeZone;
            var tz_stored = localStorage.getItem(LS.DISPLAY_TZ) || tz_event;
            
            if (tz_stored) {
                if ((tz_event != tz_stored) && (tz_device != tz_stored)) {
                    tz_stored = null;
                }
            }
            var tz_chosen = tz_stored || tz_event || tz_device;
            context.dispatch('updateDisplayTZ', tz_chosen);
        },

        // Standard auth/loading logic to be run on App.created()
        // bootstrapOnCreate({dispatch}) {
        bootstrapOnCreate(context) {
            context.commit('SET_LOADING', 0);

            if (EventService.isAnonymous()) {
                return Promise.all([
                    context.dispatch('loadLocalStorage'),
                    // context.dispatch('messages/backgroundSocket'),
                    // context.dispatch('messages/fetchMyPointers'),
                    context.dispatch('me/fetchMe', true), // Attendee/Org will be blank
                    context.dispatch('loadEventData', true)
                ]).catch(error => {
                    console.log('bootstrap failed: ', error.message)
                    context.commit('SET_LOADING', 101); // Error state
                    throw new Error('Could not bootstrap');
                 }).then(() => {
                    context.dispatch('loadTimezone');
                    context.dispatch('loadingComplete');
                });
            } else {
                context.commit('SET_ATTENDEE_ID', EventService.getMandatedAttendeeId());
                return Promise.all([
                    context.dispatch('checkAuthToken')
                  ]).then(() => {
                      intervalRenewToken = setInterval(() => {
                          context.dispatch('renewAuthToken');
                      }, HOUR_IN_MS);
      
                      return Promise.all([
                          context.dispatch('loadLocalStorage'),
                          context.dispatch('messages/backgroundSocket'),
                          context.dispatch('messages/fetchMyPointers'),
                          context.dispatch('me/fetchMe', true),
                          context.dispatch('loadEventData', true)
                      ]).catch(error => {
                          console.log('bootstrap failed: ', error.message)
                          context.commit('SET_LOADING', 101); // Error state
                          throw new Error('Could not bootstrap');
                       });
      
                  }).then(() => {
                      context.dispatch('loadTimezone');
                      context.dispatch('loadingComplete');
                  }).catch(error => {
                      console.log('bootstrap failed: ', error.message)
                   });
            }
            /*
            return Promise.all([
              context.dispatch('checkAuthToken')
            ]).then(() => {
                intervalRenewToken = setInterval(() => {
                    context.dispatch('renewAuthToken');
                }, HOUR_IN_MS);

                return Promise.all([
                    context.dispatch('loadLocalStorage'),
                    context.dispatch('messages/backgroundSocket'),
                    context.dispatch('messages/fetchMyPointers'),
                    context.dispatch('me/fetchMe'),
                    context.dispatch('loadEventData')
                ]).catch(error => {
                    console.log('bootstrap failed: ', error.message)
                    context.commit('SET_LOADING', 101); // Error state
                    throw new Error('Could not bootstrap');
                 });

            }).then(() => {
                context.dispatch('loadingComplete');
            }).catch(error => {
                console.log('bootstrap failed: ', error.message)
             });
             */
        },
        // Symmetrical cleanup functions to balance bootstrapOnCreate
        cleanupOnDestroy() {
            clearInterval(intervalRenewToken);
        }
    },
    getters: {
        /*
        attendeesWithOrganisations(state, getters, rootState, rootGetters) {
            const attendees = [];
            const allAttendees = rootGetters['attendees/attendees'];

            for (let i = 0; i < allAttendees.length; i++) {
                let curAttendee = allAttendees[i];
                let curOrganisation = rootGetters['organisations/organisationById'](curAttendee.organisation_id);
                attendees.push(
                    mergeAll(
                        curAttendee,
                        curOrganisation,
                        {
                            ...flattenAnswers(curAttendee.answers),
                            ...flattenAnswers(curOrganisation.answers),
                            ...{group_name: curOrganisation.group.name},
                        }
                    )
                );
            }
            return attendees;
        },
        organisationsWithAttendees(state, getters, rootState, rootGetters) {
            const orgs = [];
            const allOrgs = rootGetters['organisations/organisations'];
            for (let i = 0; i < allOrgs.length; i++) {
                let curOrganisation = allOrgs[i];
                let curAttendees = [];
                if (rootGetters['attendees/attendee'] && rootGetters['attendees/attendee'].length) {
                    curAttendees = rootGetters['attendees/attendee'].filter(attendee => attendee.organisation_id == curOrganisation.id);
                }

                let curAttendee = {answers: []};
                if (curAttendees.length == 1) {
                    curAttendee = curAttendees[0];
                } else if (curAttendees.length > 1) {
                    // Setup arrays for each attendee field
                    SEARCHABLE_FIELDS_ATTENDEE.forEach(function(key){
                       curAttendee[key] = [];
                    });
                    for (let x=0; x< curAttendees.length; x++) {
                        let addAttendee = curAttendees[x];
                        SEARCHABLE_FIELDS_ATTENDEE.forEach(function(key){
                            curAttendee[key].push(addAttendee[key]);
                        });
                        curAttendee.answers.concat(addAttendee.answers);

                    }
                }

                orgs.push(
                    mergeAll(

                        curOrganisation,
                        curAttendee,
                        {
                            ...flattenAnswers(curAttendee.answers),
                            ...flattenAnswers(curOrganisation.answers),
                            ...{group_name: curOrganisation.group.name},
                        }
                    )
                );
            }
            return orgs;
        },
        */
        canSearch(state) {
            if (state.me.me.urls && (SEARCH_BUTTON_ENABLED in state.me.me.urls)) {
                return true;
            } else {
                console.log('canSearch getter failed');
                return false;
            }
        },
        canMessage(state) {
            if (state.me.me.urls && (SETTING_MESSAGES_ON in state.me.me.urls)) {
                return true;
            } else {
                console.log('canSearch getter failed');
                return false;
            }
        },
        canBookmark(state) {
            return (state.me.me.urls && (SETTING_NOTE_ENABLE in state.me.me.urls))
        },
        isLoading(state) {
            return state.loading < 100;
        },
        isLoadError(state) {
            return state.loading === 101;
        },
        isLoaded(state) {
            return state.loading === 100;
        },
        isAuthenticated(state) {
            // Has an authentication token been retrieved from cache/server?
            return Boolean(state.authTokenUpdatedAt); // It's a timestamp - we just need a yes/no
        },
        isAnonymous(state) {
            return state.attendeeId == 0;
        },
        loggedIn(state) {
            // Short-circuit for reloads
            // CONFLICT BETWEEN EventService.isAnonymous() AND EventService.hasAuthToken()
            // if (EventService.hasAuthToken()) {
            //     console.log("hasAuthToken");
            //     return true;
            // }

            return state.me.me.attendee && ('id' in state.me.me.attendee);
        },
        currentAttendeeName(state) {
            return state.attendeeName;
        },
        isManager(state) {
            return state.isManager;
        },
        currentAttendee(state) {
            return state.me.me.attendee;
        },
        currentAttendees(state) {
            // Current attendee AND all their colleagues
            return state.me.me.attendees;
        },
        currentOrganisation(state) {
            return state.me.me.organisation;
        },
        currentEventId(state) {
            return state.me.me.event.id;
        },
        currentEvent(state) {
            return state.me.me.event;
        },
        currentProfile(state) {
            return state.profileBlob;
        },
        settingValue: (state) => (name, def=null) => {
            if (state.me.me.settings && (name in state.me.me.settings)) {
                return state.me.me.settings[name];
            }
            return def;
        },
        displayTZ(state) {
            return state.displayTZ;
        },
    }
});